// Английски речник: ключ = българският текст от кода, стойност = превод.
// Разделен по части на приложението, за да се поддържа лесно. Липсващ
// ключ → показва се българският текст.
import { EN_COMMON } from './en.common';
import { EN_AUTH } from './en.auth';
import { EN_LANDLORD } from './en.landlord';
import { EN_ROLES } from './en.roles';

export const EN: Record<string, string> = {
  ...EN_COMMON,
  ...EN_AUTH,
  ...EN_LANDLORD,
  ...EN_ROLES,
};
